import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import './App.css'
import Footer from './components/layout/footer/Footer';
import Top from './components/layout/top/Top';
import Routers from './Routers';

function App() {
    return (
        <>
            <BrowserRouter>
                    <Top />
                    <ToastContainer autoClose={3000} />
                    <Routers />
                    <Footer />

            </BrowserRouter>

        </>
    );
}

export default App;
